module.exports = __webpack_public_path__ + "static/media/family.2e279a3f.png";